import { Component } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  InsiderRelationship,
  InsiderRelationshipMappingFilter,
  InsiderRelationshipToMap,
} from "src/api/models";
import { InsiderRelationshipMappingService } from "src/api/services";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";
import { AddInsiderCommentComponent } from "../../modals/add-insider-comment/add-insider-comment.component";
// import { FormType } from "src/api/models";
enum FormType {
  ALL = "All",
  PARENT = "Parent",
  CHILD = "Child",
  NONE = "None",
}

@Component({
  selector: "insider-relationship-app-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class InsiderRelationshipUnprocessedComponent {
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  unprocessedInsiderRelationship: any[] = [];
  unprocessedChildInsiderRelationship: any[] = [];
  selectedParentRow: any = null;
  isChildSearchTriggered: boolean = false;
  selectedChildRows: any = null;

  selectedDialogRow: any = null;
  formTypes: FormType[] = Object.values(FormType);
  // Pagination for Security
  first = 0;
  rows = 10;
  childFirst = 0;
  childRows = 10;
  searchByParentName?: string;
  selectedColorType?: FormType | undefined;
  searchByChildName?: string;
  reason?: string;
  isLoading: boolean = false;
  isChildLoading: boolean = false;
  relationshipOptions: { label: string; value: string }[] = [];
  ref!: DynamicDialogRef;
  constructor(
    private _messageService: MessageService,
    private _insiderRelationshipMappingService: InsiderRelationshipMappingService,
    public dialogService: DialogService,
  ) {}

  ngOnInit(): void {
    this.relationshipOptions = InsiderRelationship.values().map((v) => ({
      label: v,
      value: v,
    }));
  }

  onParentCheckboxChange(insider: any) {
    if (this.selectedParentRow?.insiderId === insider.insiderId) {
      this.selectedParentRow = null;
    } else {
      this.selectedParentRow = insider;
    }
  }
  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedInsiderRelationship();
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedInsiderRelationship();
  }
  getUnprocessedInsiderRelationship() {
    const params: InsiderRelationshipMappingFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      relation: this.selectedColorType || "All",
      searchByName: this.searchByParentName,
    };
    this.isLoading = true;
    this._insiderRelationshipMappingService.getParentInsider(params).subscribe({
      next: (value) => {
        this.unprocessedInsiderRelationship = value ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedInsiderRelationship?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  getChildInsiderRelationship() {
    const params: InsiderRelationshipMappingFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      searchByName: this.searchByChildName || undefined,
      insiderIdToSkip: this.selectedParentRow?.insiderId || null,
    };
    this.isChildLoading = true;
    this._insiderRelationshipMappingService.getChildInsider(params).subscribe({
      next: (value) => {
        this.unprocessedChildInsiderRelationship = value ?? [];
      },
      error: (err) => {
        this.isChildLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedChildInsiderRelationship?.[0]?.totalCount ?? 0;
        this.isChildLoading = false;
      },
    });
  }
  loadChildData(event: any) {
    if (!this.isChildSearchTriggered) return;
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.childFirst = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.childFirst = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getChildInsiderRelationship();
  }
  childPageChange(event: any) {
    this.childFirst = event.first;
    this.childRows = event.rows;
  }
  onChildSearch() {
    if (!this.selectedParentRow) {
      this._messageService.add({
        summary: "Please select a parent record first.",
        severity: "warn",
      });
      return;
    }
    this.childFirst = 0;
    this.paginator.pageNumber = 1;
    this.getChildInsiderRelationship();
  }
  onMapClick(data?: { parentComment?: string; children?: Array<{ insiderId: number; insiderComment?: string }> }) {
    if (
      this.selectedChildRows &&
      this.selectedChildRows.length > 0 &&
      (!this.reason || this.reason.trim() === "")
    ) {
      this._messageService.add({
        severity: "warn",
        summary: "Warning",
        detail: "Reason is required when child rows are selected.",
      });
      return;
    }
    
    // Build children array with insiderId and insiderComment
    const children = data?.children || [];
    
    const params: InsiderRelationshipToMap = {
      children: children.length > 0 ? children : [],
      insiderRelationShip: this.reason ?? (null as unknown as string),
      parentInsiderId: this.selectedParentRow?.insiderId || null,
      insiderComment: data?.parentComment || undefined,
    } as any;
    this.isLoading = true;
    this._insiderRelationshipMappingService
      .mapInsiderRelationship(params)
      .subscribe({
        next: (value) => {
          this._messageService.add({
            summary: "Mapping successful",
            severity: "success",
          });

          //  Selection clear
          this.searchByChildName = undefined;
          this.searchByParentName = undefined;
          this.selectedColorType = undefined;
          this.selectedParentRow = null;
          this.selectedChildRows = [];
          this.reason = undefined;
          // refresh data
          this.getUnprocessedInsiderRelationship();
          this.unprocessedChildInsiderRelationship = [];
        },
        error: (err) => {
          this.isLoading = false;
          let errorMessage = "An unexpected error occurred";

          try {
            // If backend returns a JSON string, parse it
            const parsedError = JSON.parse(err.error);
            errorMessage = parsedError.message || errorMessage;
          } catch {
            // If parsing fails, fallback to direct message or text
            errorMessage = err.error?.message || err.error || errorMessage;
          }
          this._messageService.add({
            detail: errorMessage,
            severity: "error",
          });
        },

        complete: () => {
          this.paginator.totalCount =
            this.unprocessedInsiderRelationship?.[0]?.totalCount ?? 0;
          this.isLoading = false;
        },
      });
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
 openInsiderCommentModal(product?: any, event?: Event) {
    if (event) event.preventDefault();
    
    // Prepare child comments array
    const childComments = this.selectedChildRows && this.selectedChildRows.length > 0
      ? this.selectedChildRows.map((child: any) => ({
          insiderName: child.insiderName,
          insiderComment: child.insiderComment || ''
        }))
      : [];
    
    this.ref = this.dialogService.open(AddInsiderCommentComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "40vw" },
      contentStyle: { overflow: "auto" },
      header: "Add Insider Comment",
      data: {
        insiderComment: this.selectedParentRow?.insiderComment || '',
        parentComment: this.selectedParentRow?.insiderComment || '',
        parentName: this.selectedParentRow?.insiderName || '',
        hasParent: !!this.selectedParentRow,
        childComments: childComments,
        selectedChildRows: this.selectedChildRows || [], // Pass selected child rows for mapping
        onMapClick: (data?: { parentComment?: string; children?: Array<{ insiderId: number; insiderComment?: string }> }) => {
          this.onMapClick(data);
        }
      }
    });
    this.ref.onClose.subscribe((refresh) => {
    
    });
  }
  onPaste(
    event: ClipboardEvent,
    field: "searchByParentName" | "searchByChildName"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
